export const environment = {
    TITLE: 'Vierkant AI',
    production: true,
    apiUrl: 'https://api.vierkant-ai.eu',
    authUrl: 'https://auth.vierkant-ai.eu',
    FACEBOOK_APP_ID: '809083922020506',
    FACEBOOK_CONFIG_ID: '1381819616895195',
    MESSAGE_SERVER_URL: 'https://whatsapp.vierkant-ai.eu',
    LANDING_PAGE_BASE_URL: 'https://landing.vierkant-ai.eu',
};